'use strict';

var _ = require('lodash');
var ActionPrintingService = function ActionPrintingService() {
  var NL = '\n';
  var UNDEFINED = 'undefined';
  function printStrategyClosureAction(strategyClosureAction) {
    var result = [];
    result.push('for Class ' + strategyClosureAction.fareBasisCode + ' [WHERE]');
    if (!_.isNil(strategyClosureAction.loadFactor) && strategyClosureAction.loadFactor !== '') {
      result.push('LF% >= ' + strategyClosureAction.loadFactor);
    }
    if (!_.isNil(strategyClosureAction.daysToDeparture) && strategyClosureAction.daysToDeparture !== '' && !_.isNil(strategyClosureAction.loadFactor) && strategyClosureAction.loadFactor !== '') {
      result.push('[OR]');
    }
    if (!_.isNil(strategyClosureAction.daysToDeparture) && strategyClosureAction.daysToDeparture !== '') {
      result.push('DTD <= ' + strategyClosureAction.daysToDeparture);
    }
    return result.join(' ').trim() + NL;
  }
  function printStrategyAllocationAuthAvailAction(strategyAllocationAuthAvailAction) {
    var result = [];
    if (!_.isNil(strategyAllocationAuthAvailAction.allocationType) && strategyAllocationAuthAvailAction.allocationType !== '') {
      result.push('[THEN] Set Allocation Type to ' + strategyAllocationAuthAvailAction.allocationType + NL);
    }
    if (!_.isNil(strategyAllocationAuthAvailAction.minAllocation) && strategyAllocationAuthAvailAction.minAllocation !== '') {
      result.push('[THEN] Set Min Allocation to ' + strategyAllocationAuthAvailAction.minAllocation + NL);
    }
    if (!_.isNil(strategyAllocationAuthAvailAction.maxAllocation) && strategyAllocationAuthAvailAction.maxAllocation !== '') {
      result.push('[THEN] Set Max Allocation to ' + strategyAllocationAuthAvailAction.maxAllocation + NL);
    }
    if (!_.isNil(strategyAllocationAuthAvailAction.hardOverrideMinValue) && strategyAllocationAuthAvailAction.hardOverrideMinValue !== '') {
      result.push('[THEN] Set Min Authorization to ' + strategyAllocationAuthAvailAction.hardOverrideMinValue + NL);
    }
    if (!_.isNil(strategyAllocationAuthAvailAction.hardOverrideMaxValue) && strategyAllocationAuthAvailAction.hardOverrideMaxValue !== '') {
      result.push('[THEN] Set Max Authorization to ' + strategyAllocationAuthAvailAction.hardOverrideMaxValue + NL);
    }
    if (!_.isNil(strategyAllocationAuthAvailAction.hardOverrideType) && strategyAllocationAuthAvailAction.hardOverrideType !== '') {
      result.push('[THEN] Set Authorization Type to ' + strategyAllocationAuthAvailAction.hardOverrideType + NL);
    }
    if (!_.isNil(strategyAllocationAuthAvailAction.authLinkValue) && strategyAllocationAuthAvailAction.authLinkValue !== '') {
      result.push('[THEN] Set Authorization Link to ' + strategyAllocationAuthAvailAction.authLinkValue + NL);
    }
    if (!_.isNil(strategyAllocationAuthAvailAction.minAvailability) && strategyAllocationAuthAvailAction.minAvailability !== '') {
      result.push('[THEN] Set Min Availability to ' + strategyAllocationAuthAvailAction.minAvailability + NL);
    }
    if (!_.isNil(strategyAllocationAuthAvailAction.maxAvailability) && strategyAllocationAuthAvailAction.maxAvailability !== '') {
      result.push('[THEN] Set Max Availability to ' + strategyAllocationAuthAvailAction.maxAvailability + NL);
    }
    if (!_.isNil(strategyAllocationAuthAvailAction.linkValue) && strategyAllocationAuthAvailAction.linkValue !== '') {
      result.push('[THEN] Set Availability Link to ' + strategyAllocationAuthAvailAction.linkValue + NL);
    }
    if (!_.isNil(strategyAllocationAuthAvailAction.linkType) && strategyAllocationAuthAvailAction.linkType !== '') {
      result.push('[THEN] Set Link Type to ' + strategyAllocationAuthAvailAction.linkType + NL);
    }
    if (!_.isNil(strategyAllocationAuthAvailAction.className) && strategyAllocationAuthAvailAction.className !== '') {
      result.push('for Class ' + strategyAllocationAuthAvailAction.className + NL);
    }
    return result.join(' ').trim() + NL;
  }
  function printStrategyAction(strategyAction) {
    var value = fetchValidValue(strategyAction.value, strategyAction.formattedValue);
    var result = [strategyAction.category, strategyAction.criterion || UNDEFINED, strategyAction.action || UNDEFINED];
    if (strategyAction.action !== 'Remove') {
      result.push(value === '' ? UNDEFINED : value);
      if (strategyAction.argsNo > 1) {
        result.push(fetchValidValue(strategyAction.secondValue, strategyAction.formattedSecondValue));
        if (strategyAction.argsNo > 2) {
          result.push(fetchValidValue(strategyAction.thirdValue, strategyAction.formattedThirdValue));
        }
      }
    }
    if (['Reduce by (Abs)', 'Increase by (Abs)'].indexOf(strategyAction.action) > -1) {
      result = [strategyAction.category, strategyAction.criterion, strategyAction.action || UNDEFINED, value || UNDEFINED, ', End RTP =', fetchValidValue(strategyAction.secondValue, strategyAction.formattedSecondValue), ', Start RTP =', fetchValidValue(strategyAction.thirdValue, strategyAction.formattedThirdValue)];
    }
    return result.join(' ').trim() + NL;
  }
  function fetchValidValue(value, formattedValue) {
    return _.isNil(value) && _.isNil(formattedValue) ? UNDEFINED : _.isNil(formattedValue) && !_.isNil(value) ? value : _.isNil(value) && !_.isNil(formattedValue) ? formattedValue : !_.isNil(value) && !_.isNil(formattedValue) && formattedValue !== value ? value : formattedValue;
  }
  return {
    printStrategyClosureAction: printStrategyClosureAction,
    printStrategyAllocationAuthAvailAction: printStrategyAllocationAuthAvailAction,
    printStrategyAction: printStrategyAction,
    fetchValidValue: fetchValidValue
  };
};
module.exports = ActionPrintingService;